import { render, staticRenderFns } from "./NotificationPreferenceSetting.vue?vue&type=template&id=edb1c76c&scoped=true&"
import script from "./NotificationPreferenceSetting.vue?vue&type=script&lang=ts&"
export * from "./NotificationPreferenceSetting.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPreferenceSetting.vue?vue&type=style&index=0&id=edb1c76c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb1c76c",
  null
  
)

export default component.exports